export default __webpack_public_path__ + "static/media/INQUIRY_NOW.9657133a.jpg";